<p-toast position="top-right" appendTo="body"></p-toast>

<res-layout>
  <res-header>
    <res-logo appName="Insecta" pBadge style="font-size: 2rem" value="{{ environment }}" severity="danger" [showAppName]="false" *ngIf="!isProd">
      <img res-logo src="assets/images/logo.png" style="width: auto; height: 70px" />
    </res-logo>

    <res-logo appName="Insecta" [showAppName]="false" *ngIf="isProd">
      <img res-logo src="assets/images/logo.png" style="width: auto; height: 70px" />
    </res-logo>

    <res-navigation>
      <!-- Add your Navigation Here -->
      <res-navigation-item *ngIf="permissions.canViewRequestorDashboard && !permissions.canViewInsectaryDashboard">
        <a routerLink="/requesterdashboard" data-testid="requesterDashboard">Dashboard</a>
      </res-navigation-item>
      <res-navigation-item *ngIf="!permissions.canViewRequestorDashboard && permissions.canViewInsectaryDashboard">
        <a routerLink="/insectarydashboard" data-testid="insectaryDashboard">Dashboard</a>
      </res-navigation-item>
      <res-navigation-group name="Dashboard" *ngIf="permissions.canViewInsectaryDashboard && permissions.canViewRequestorDashboard">
        <res-navigation-item *ngIf="permissions.canViewRequestorDashboard">
          <a routerLink="/requesterdashboard" data-testid="requesterDashboard">Requester Dashboard</a>
        </res-navigation-item>
        <res-navigation-item *ngIf="permissions.canViewInsectaryDashboard">
          <a routerLink="/insectarydashboard" data-testid="insectaryDashboard">Insectary Dashboard</a>
        </res-navigation-item>
      </res-navigation-group>

      <res-navigation-group name="Admin" *ngIf="permissions.configureSiteCatalogs || permissions.configureSecurity">
        <res-navigation-item *ngIf="permissions.configureSiteCatalogs">
          <a routerLink="/admin/catalogs" data-testid="siteCatalogs">Site Catalogs</a>
        </res-navigation-item>
        <res-navigation-item *ngIf="permissions.configureSiteCatalogs"
          ><a routerLink="/admin/globallists" data-testid="navGlobalLists">Global Lists</a></res-navigation-item
        >
        <res-navigation-item *ngIf="permissions.canViewMetrics"
          ><a routerLink="/admin/metrics" data-testid="navMetrics">Metrics</a>
        </res-navigation-item>
        <res-navigation-item *ngIf="permissions.configureSecurity">
          <a routerLink="/admin/security" data-testid="navSecurity">Security</a>
        </res-navigation-item>
      </res-navigation-group>
    </res-navigation>
    <div res-app-settings data-testid="settings-gear-icon" id="settings-gear">
      <app-app-user-settings [appUser]="appUser"></app-app-user-settings>
    </div>
  </res-header>
  <!-- Add your application content here (eg: Router Outlet)-->
  <router-outlet />

  <res-footer version="one hunnit">
    <div res-footer-content>
      <ul>
        <li>
          <a style="color: white" href="https://corteva-crop.atlassian.net/servicedesk/customer/portal/41" target="_blank" data-testid="navContact">
            Contact Support
          </a>
        </li>
      </ul>
    </div>
    <div res-footer-application-details>
      <div class="d-flex justify-content-end">
        <div>
          <div class="ml-3 align-self-center" *ngIf="true"></div>
        </div>
      </div>
      <ul>
        <li>
          <span> Version: {{ versionService.buildNumber }} </span>
        </li>
        <li>Developed by Team Voyager</li>
        <li>Internal Use Only</li>
      </ul>
    </div>
  </res-footer>
</res-layout>
